import { createContext, ReactChildren } from 'react';

export type CustomPageValueType = {
  children?: ReactChildren;
};

export const CustomPageContext = createContext<CustomPageValueType>({
  children: undefined,
});

export const CustomPageProvider = CustomPageContext.Provider;
export const CustomPageConsumer = CustomPageContext.Consumer;
